import { render } from "./RecieversGroupEditComponent.vue?vue&type=template&id=2a26e84f&scoped=true"
import script from "./RecieversGroupEditComponent.vue?vue&type=script&lang=js"
export * from "./RecieversGroupEditComponent.vue?vue&type=script&lang=js"

import "./RecieversGroupEditComponent.vue?vue&type=style&index=0&id=2a26e84f&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a26e84f"]])

export default __exports__